"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PlayerInfo = (0, vue_1.resolveComponent)("PlayerInfo");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.formatCssClass()),
        key: _ctx.componentKey
    }, [
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_PlayerInfo, {
            player: _ctx.playerView.thisPlayer,
            playerView: _ctx.playerView,
            actionLabel: '',
            playerIndex: 0,
            hideZeroTags: true,
            isTopBar: true
        }, null, 8, ["player", "playerView"]), [
            [vue_1.vShow, _ctx.isExpanded()]
        ]),
        (0, vue_1.createElementVNode)("div", {
            class: "top-bar-collapser",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleBar()))
        }, [...(_cache[1] || (_cache[1] = [
                (0, vue_1.createElementVNode)("img", { src: "assets/arrows_left.png" }, null, -1)
            ]))])
    ], 2));
}
